import { useState, useEffect } from "react";
import Sidebar from "@/pages/sidebar/sidebar";
import ClientMainHeader from "@/pages/header";
import { MainWrapper } from "@/pages/styled";
import { LimitedAccountWarning } from "@/components/limited-account-warning";
import { MerchantProcessingBanner } from "@/components/merchant-processing-banner";
import ContactTable from "@/components/contact/contact-table";

const Contacts = () => {
  const [currentWidth, setCurrentWidth] = useState(0);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function handleResize() {
    const width = window.innerWidth;
    setCurrentWidth(width);
  }

  return (
    <div>
      <Sidebar currentWidth={currentWidth} setCurrentWidth={setCurrentWidth} />
      <>
        <LimitedAccountWarning />
        <MerchantProcessingBanner />
        <MainWrapper>
          <ClientMainHeader title="Contacts" />
          <div className="mt-4 lg:mt-12">
            <ContactTable />
          </div>
        </MainWrapper>
      </>
    </div>
  );
};

export default Contacts;
